import React, { useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import useFetch from '../Utilities/useFetch';
import 'bootstrap/dist/css/bootstrap.min.css';
import CollectorClaimModal from '../Claims/ClaimModal/CollectorClaimModal';
import { Button, Row, Col } from 'react-bootstrap'
      

const ReportTemplateDateClick = ({
    columnDefs,
    apiUrl,
    reportName
}) => {
    const [date, setDate] = useState(new Date().toISOString().split('T')[0]); // Initialize with today's date
    const [selectedDebtorId, setSelectedDebtorId] = useState(null);
    const [rowData, setRowData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [gridApi, setGridApi] = useState();
    
// I fixed the format you had for the fetch call
    // I left your old code commented out so you could see the difference
    // const { data, error } =  useFetch(true, `${apiUrl}?reportDate=${date}`, 'GET');
    const { data, error } =  useFetch(true, apiUrl, 'GET', null, {reportDate:date});
    

    // I wrapped this if statement in a useEffect so react can keep better track of the state
    useEffect(()=>{
        if (error) {
            setRowData([]); // Clear data if the response is not OK
            console.error('Error fetching data:'+{date}, error);
        }
    // because error is in this array, this will only run if error changes
    // eslint-disable-next-line
    },[error]);

    useEffect(() => {
        if (data) {
            setRowData(data);
        }
    }, [data]);
   
     const handleDateChange = (newDate) => {
        setDate(newDate);
    };

    const onBtnExport = () => {
        const textColumns = ['clientRefNo', 'RefNo']; // columns to format as text
        const dateColumns = ['listdate','statusDate','depositDate','dateReceived','dateRemitted']; // columns to format as date
        gridApi.exportDataAsCsv({
        processCellCallback: (params) => {
            if (textColumns.includes(params.column.getColId())) {
                return params.value != null ? "'" + params.value : '';
            }
            if (dateColumns.includes(params.column.getColId())) {
                const date = new Date(params.value);
                // convert to standard date string
                const formattedDate = isNaN(date.getTime()) ? '' : date.toLocaleDateString();

                return formattedDate;
            }

            return params.value;
        }
    });
    }
    const onGridReady = (params) => {
        setGridApi(params.api);
    }
    
    const onCellClicked = (event) => {
        setSelectedDebtorId(event.data.debtorid);
        setIsModalOpen(true);
    };
  const closeModal = () => {
        setIsModalOpen(false);
    };
    // Not best practice to have code outside of useEffects, this code is already in a useEffect on line 26
    // if (error) {
    //     console.error('Error fetching data:', error);
    // }
 
    const onFilterChanged = (e) => {
        
    }
    // I'm not sure the advantage of this component, but I left it as is
    // You could simply put the input in the ReportTemplateDateNoClick return statement
    const DatePicker = ({ value }) => {
        return (
            <input
                type="date"
                value={value}
                onChange={(e) =>  handleDateChange(e.target.value)}
            />
        );
    };

    return (
        <div>
            <h4 className='margin'>{reportName}</h4>
            <Row><Col>
            <div className="date-picker">
                <label htmlFor="report-date">Select Report Date: &nbsp;</label>
                <DatePicker value={date} /> 
                <span> &nbsp; Row Count: {rowData.length}</span>
                <span> &nbsp; Payments: {rowData.reduce((sum, row) => sum + (row.paymentAmount || 0), 0).toFixed(2)}    </span>
            </div>
            </Col>
            <Col className='export-button'>
                     <Button variant='secondary' onClick={onBtnExport}>Download CSV</Button>
                 </Col>
            </Row>
            {error && <div className="error-message">Error fetching data: {error.message}</div>}
            <div className="ag-theme-quartz compact-theme grid">
                
                <AgGridReact
                    rowData={rowData}
                    columnDefs={columnDefs}
                    defaultColDef={{ sortable: true, filter: true }}
                    onCellClicked={onCellClicked}
                    onFirstDataRendered={(params) => params.api.sizeColumnsToFit()}
                    onGridReady={onGridReady}
                    onFilterChanged={onFilterChanged}
                />
            </div>
                       {isModalOpen && (
                <CollectorClaimModal
                    selectedClaim={selectedDebtorId}
                    setSelectedClaim={setSelectedDebtorId}
                    show={isModalOpen}
                    setShow={closeModal}
                />
            )}
 
         </div>
    );
};

export default ReportTemplateDateClick;